import { memo, MouseEvent, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Link, MenuItem, Popover } from '@mui/material';

interface Props {
  onResendCode: () => void;
  onCallMe: () => void;
}

const SmsBackupOptions = (props: Props): React.JSX.Element => {
  const { onCallMe, onResendCode } = props;

  const [popoverAnchor, setPopoverAnchor] = useState<HTMLAnchorElement | null>(null);

  const handleClosePopover = useCallback(() => {
    setPopoverAnchor(null);
  }, []);

  const handleResendCode = useCallback(() => {
    onResendCode();
    setPopoverAnchor(null);
  }, [onResendCode]);

  const handleCallMe = useCallback(() => {
    onCallMe();
    setPopoverAnchor(null);
  }, [onCallMe]);

  const handleOpenPopover = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    setPopoverAnchor(e.currentTarget);
  }, []);

  return (
    <>
      <Box mt={1}>
        {/* FIXME: make this anchor a button */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          style={{
            cursor: 'pointer',
          }}
          onClick={handleOpenPopover}
          underline="hover"
        >
          <FormattedMessage defaultMessage="Didn't receive the notification?" />
        </Link>
      </Box>
      <Popover anchorEl={popoverAnchor} onClose={handleClosePopover} open={Boolean(popoverAnchor)}>
        <MenuItem onClick={handleCallMe}>
          <FormattedMessage defaultMessage="Call me instead" />
        </MenuItem>
        <MenuItem onClick={handleResendCode}>
          <FormattedMessage defaultMessage="Resend Code" />
        </MenuItem>
      </Popover>
    </>
  );
};

export default memo(SmsBackupOptions);
